import React from "react";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./Blurb.module.css"; 

const Blurb = ({id, text, text_two, imageOneSrc, imageTwoSrc, imageOneId, imageTwoId, metric}) => {

  const fontSchemes = useFont();    
  const fontFamilyOne = fontSchemes.scheme_one; 

  return (
    <div className={`${styles.blurb} ${styles[id]} ${fontFamilyOne} ${id}`} style={{backgroundColor: "white"}}>
      <p className={styles.blurb_text}>{text}</p>
      <div className={`${styles.blurb_bottom} ${styles[`${id}_bottom`]}`}>
        <p className={styles[metric]}>{text_two}</p>
        <img src={imageOneSrc} alt="Arrow" className={styles[imageOneId]} />
        <img src={imageTwoSrc} alt="Graph" className={styles[imageTwoId]} />
      </div>
    </div>
  );
};

export default Blurb;